/*
 * imd-localization-flags.js
 * Builds the country-picker dropdown list (flag + currency + name) on first open, from the
 * shared #imd-country-data JSON emitted once in theme.liquid. This keeps ~700 flag <img> and
 * ~770 <li> out of the initial DOM on every page (3 country pickers x ~240 countries).
 *
 * 2026-09-30: the language pickers work the same way from #imd-language-data (the 42-language
 * list used to be rendered in full into every picker: ~24 KB of HTML per page).
 *
 * Selection wiring mirrors assets/localization-form.js onItemClick: set the form's
 * country_code / locale_code input to the chosen ISO and submit. No-JS users get the native
 * <select> fallback.
 */
(function () {
  var cache = {};

  function getData(id) {
    if (cache[id]) return cache[id];
    var el = document.getElementById(id);
    if (!el) return [];
    try {
      cache[id] = JSON.parse(el.textContent);
    } catch (e) {
      cache[id] = [];
    }
    return cache[id];
  }

  function makeLink(iso, current, input, formEl) {
    var a = document.createElement('a');
    a.className =
      'link link--text disclosure__link caption-large focus-inset' +
      (iso === current ? ' disclosure__link--active' : '');
    a.href = '#';
    a.setAttribute('data-value', iso);
    if (iso === current) a.setAttribute('aria-current', 'true');
    a.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (input) input.value = iso;
      if (formEl) formEl.submit();
    });
    return a;
  }

  function countryItem(c, current, input, formEl) {
    var iso = c.i;
    var lc = (iso || '').toLowerCase();
    var a = makeLink(iso, current, input, formEl);

    var img = document.createElement('img');
    img.className = 'localization-flag';
    img.src = 'https://flagcdn.com/w20/' + lc + '.png';
    img.srcset = 'https://flagcdn.com/w40/' + lc + '.png 2x';
    img.width = 18;
    img.height = 13;
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.loading = 'lazy';
    img.decoding = 'async';
    // flagcdn lacks a few territories (e.g. 'ac' Ascension Island): hide the broken
    // image but keep its 18x13 box so the row text stays aligned with the others.
    img.onerror = function () { this.style.visibility = 'hidden'; };

    var span = document.createElement('span');
    span.className = 'localization-form__currency';
    span.textContent = c.c + ' ' + c.s + ' |';

    a.appendChild(img);
    a.appendChild(span);
    a.appendChild(document.createTextNode(' ' + c.n));
    return a;
  }

  function languageItem(l, current, input, formEl) {
    var a = makeLink(l.i, current, input, formEl);
    a.setAttribute('hreflang', l.i);
    a.setAttribute('lang', l.i);
    a.textContent = l.n;
    return a;
  }

  var KINDS = [
    {selector: 'ul[data-imd-country-list]', data: 'imd-country-data', input: 'country_code', item: countryItem},
    {selector: 'ul[data-imd-language-list]', data: 'imd-language-data', input: 'locale_code', item: languageItem},
  ];

  function build(ul, kind) {
    if (ul.dataset.imdBuilt) return;
    var items = getData(kind.data);
    if (!items.length) return;
    ul.dataset.imdBuilt = '1';

    var current = ul.getAttribute('data-current');
    var form = ul.closest('localization-form');
    var input = form ? form.querySelector('input[name="' + kind.input + '"]') : null;
    var formEl = form ? form.querySelector('form') : null;
    var frag = document.createDocumentFragment();

    items.forEach(function (entry) {
      var li = document.createElement('li');
      li.className = 'disclosure__item';
      li.setAttribute('tabindex', '-1');
      li.appendChild(kind.item(entry, current, input, formEl));
      frag.appendChild(li);
    });

    ul.appendChild(frag);
  }

  function init() {
    KINDS.forEach(function (kind) {
      document.querySelectorAll(kind.selector).forEach(function (ul) {
        var form = ul.closest('localization-form');
        var btn = form ? form.querySelector('button') : null;
        if (!btn) {
          build(ul, kind); // no disclosure button found — build immediately so the list is never empty
          return;
        }
        // Build on first interaction (pointer or keyboard) with the picker button.
        var onceBuild = function () { build(ul, kind); };
        btn.addEventListener('mousedown', onceBuild);
        btn.addEventListener('focus', onceBuild);
        btn.addEventListener('click', onceBuild);
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
